import { render, staticRenderFns } from "./ChatGroupSide.vue?vue&type=template&id=a2a61ee0&scoped=true"
import script from "./ChatGroupSide.vue?vue&type=script&lang=js"
export * from "./ChatGroupSide.vue?vue&type=script&lang=js"
import style0 from "./ChatGroupSide.vue?vue&type=style&index=0&id=a2a61ee0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../T88/build-source/web/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2a61ee0",
  null
  
)

export default component.exports